<template>
    <div class="py-4 bg-secondary">
    <div class="profile-page">
      <section class="section-new">
        <div class="container">
          <el-row>
            <el-col :span="24">
              <div class="card card-lift shadow border-0 card-address_page mb-3">
                <el-breadcrumb separator-class="el-icon-arrow-right" class="vertical-center">
                  <el-breadcrumb-item :to="{ path: '/' }">{{$t('menu.main')}}</el-breadcrumb-item>
                  <el-breadcrumb-item>{{$t('menu.pro_active')}}</el-breadcrumb-item>
                  <el-breadcrumb-item>{{$t('submenu.ijro-intizomi')}}</el-breadcrumb-item>
                </el-breadcrumb>
              </div>
            </el-col>
          </el-row>
        </div>
      </section>
      <section class="section py-1 mb-3">
        <div class="container">
          <card shadow class="card_radius_no" no-body style="z-index: 10;">
            <div class="px-4">
              <div class="mt-3 py-3 text-center">
                <div class="row justify-content-center">
                  <div class="col-lg-11">
                    <div v-html="$i18n.locale === 'uz-UZ' ? ijroIntizomi.contentUz : $i18n.locale === 'ru-RU' ? ijroIntizomi.contentRu : $i18n.locale === 'en-US' ? ijroIntizomi.contentEn : ijroIntizomi.contentUzCyr">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </card>
        </div>
      </section>
    </div>
    </div>
</template>
<script>
    import axios from "axios";

    export default {
        data() {
            return {
                activeName: '1',
                ijroIntizomi: []
            };
        },
      mounted() {
        axios.get(`https://www.prokuratura.uz/api/ijro-intizomi-for-web-page/1`)
            .then(response => {
              this.ijroIntizomi = response.data
            })
      }
    }
</script>
<style>
</style>
